/* @ngInject */
export function formatTime (Time) {
	return function (time) {
		return Time.formatTime(time);
	};
}
